var map = {
	"./cloud1.webp": "6c61",
	"./cloud2.webp": "66aa",
	"./cloud3.webp": "a1f3",
	"./cloud4.webp": "96f4",
	"./cloud5.webp": "4bda",
	"./cloud6.webp": "9d5d",
	"./cloud7.webp": "0d79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2f6";